import React, { useState } from 'react';
import { Grid } from '@mui/material';
import Header from '../Header/Header';
import CustomerSelector from '../Common/CustomerSelector';
import SiteSelector from '../Common/SiteSelector';
import { CustomerDTO, SiteDTO } from '@beable/roster-backend-client-v1';
import SchoolSelector from '../Common/Selectors/SchoolSelector';
import UserSearch from './UserSearch';
import { StyledPanelHeader } from '../Common/Layout/PanelHeader';
import { BasePanelBox } from '../Common/Layout/BasePanelBox';
import BaseSheet from '../Common/Layout/BaseSheet';
import BasePanel from '../Common/Layout/BasePanel';
  
export default function UserSupport() {
  const [customer, setCustomer] = useState<CustomerDTO>();
  const [site, setSite] = useState<SiteDTO>();
  const [schoolId, setSchoolId] = useState<string>();


  const handleCustomerChange = (customer: CustomerDTO | undefined) => {
    resetSelections();
    setCustomer(customer);
  }

  const handleSiteChange = (site: SiteDTO | undefined) => {
    resetSelections();
    setSite(site);
  }

  const resetSelections = () => {
    setSite(undefined);
    setSchoolId(undefined);
  }

  return (
    <>
      <Header />
      <Grid container>
        <BasePanel>
          <BasePanelBox>
            <StyledPanelHeader header="User Support" />
          <Grid container size={12}>
            <CustomerSelector
              onSelect={handleCustomerChange}
              variant='outlined'
            />
            <SiteSelector
              customerId={customer ? customer.id : ''}
              onSelect={handleSiteChange}
              disabled={!customer}
              variant='outlined'
            />
            <SchoolSelector
              siteId={site ? site.id : 0}
              onChange={(schoolId: string) => setSchoolId(schoolId)}
              allOption={true}
              variant='outlined'
              disabled={!site}
          />
          </Grid>
          </BasePanelBox>
        </BasePanel>
        <BaseSheet id="user-search-container" maxWidth='lg'>
          <Grid size={12}>
            <UserSearch
              site={site}
              orgId={schoolId}
            />
          </Grid>
        </BaseSheet>
      </Grid >
    </>
  );
}
